import React from 'react';
import ReactModal from "react-modal";
import {Customer} from '../../../../types/admin/room';
import useLoading from '../../../../hooks/useLoading';

interface ConfirmAddCustomerRoomMemberModalProps {
  customer: Customer
  onClosed: () => Promise<void>;
  onAccepted: () => Promise<void>;
}

export const ConfirmAddCustomerRoomMemberModal = (props: ConfirmAddCustomerRoomMemberModalProps) => {
  const { customer, onClosed, onAccepted } = props;
  const withLoading = useLoading();

  const handleAddButtonClick = async () => {
    withLoading(async () => {
      await onClosed;
      await onAccepted();
    });
  }

  return (
    <ReactModal
      isOpen
      ariaHideApp={false}
      onRequestClose={onClosed}
      overlayClassName="overlay"
      shouldCloseOnOverlayClick
      className="form-modal"
    >
      <section className="modal-background">
        <div className="form-modal-container">
          <div className="form-modal-title">
            <h1 className="font-semibold">顧客追加</h1>
            <button
              type="button"
              className="modal-close-btn"
              onClick={onClosed}
            >
              ×
            </button>
          </div>

          <div className='form-modal-content'>
            <div className="grid grid-cols-1 w-full">
              <span className="text-sm font-semibold text-primary mb-4">下記のユーザがヒットしました。データを確認して追加してください。</span>
              <table className="w-full table-fixed mt-2">
                <tbody className="text-sm">
                <tr>
                  <td>お名前</td>
                  <td>{ customer?.userName }</td>
                </tr>
                <tr>
                  <td>会社名</td>
                  <td>{ customer?.companyName }</td>
                </tr>
                <tr>
                  <td>部署名</td>
                  <td>{ customer?.department }</td>
                </tr>
                <tr>
                  <td>役職</td>
                  <td>{ customer?.position }</td>
                </tr>
                <tr>
                  <td>E-mail</td>
                  <td>{ customer?.email }</td>
                </tr>
                <tr>
                  <td>郵便番号</td>
                  <td>{ customer?.zip }</td>
                </tr>
                <tr>
                  <td>住所</td>
                  <td>{ customer?.address }</td>
                </tr>
                <tr>
                  <td>建物名</td>
                  <td>{ customer?.building }</td>
                </tr>
                <tr>
                  <td>電話番号</td>
                  <td>{ customer?.tel }</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="form-modal-footer-container">
            <div className="form-modal-footer">
              <button
                className="float-left btn-sub"
                type="button"
                onClick={onClosed}
              >
                キャンセル
              </button>
              <button
                className="btn-primary"
                type="button"
                onClick={handleAddButtonClick}
              >
                追 加
              </button>
            </div>
          </div>
        </div>
      </section>
    </ReactModal>
  );
}
